import {Component, Input, OnInit} from '@angular/core';
import {forkJoin} from "rxjs";
import {
  ExpertiseService,
  IDictionary,
  IExpertiseDoc,
  ISampleSignInfo
} from "../../../shared/services/expertise.service";
import {finalize} from "rxjs/internal/operators/finalize";

@Component({
  selector: 'app-new-expertises',
  templateUrl: './new-expertises.component.html',
  styleUrls: ['./new-expertises.component.scss']
})
export class NewExpertisesComponent implements OnInit {
  @Input() livingComplexID: number;
  @Input() regionID: number;
  @Input() objectName: string;
  @Input() btnIsActive = false;
  expertiseTypes: IDictionary[] = [];
  expertises: IExpertiseDoc[] = [];
  sampleSignInfo: ISampleSignInfo;
  isActiveExpertises: IExpertiseDoc[] = [];
  isNotActiveExpertises: IExpertiseDoc[] = [];
  tooltip = 'Чтобы заполнить поле "Экспертиза", сохраните объект с заполненными обязательными полями.';
  loading = false;

  constructor(private expService: ExpertiseService) {
  }

  ngOnInit() {
    this.loading = true;
    forkJoin([
      this.expService.getExpertiseTypes(),
      this.expService.getExpertises(this.livingComplexID),
      this.expService.getSampleSignInfo()
    ])
      .pipe(
        finalize(() => this.loading = false),
      )
      .subscribe(res => {
      this.expertiseTypes = res[0];
      this.sampleSignInfo = res[2];
      this.divideExpertises(res[1]);
    });
  }

  divideExpertises(expertises: IExpertiseDoc[]) {
    this.expertises = expertises;
    this.expertises.forEach(exp => {
      exp.number = exp.number === 'null' ? null : exp.number;
      exp.expertiseTypeTitle = this.expertiseTypes.find(f => f.id === exp.expertiseType).title;
    });
    this.isActiveExpertises = this.expertises.filter(f => f.isActive);
    this.isNotActiveExpertises = this.expertises.filter(f => !f.isActive);
  }


  newExpertise() {
    if (this.isActiveExpertises.find(f => f.id === null)) {
      alert('У вас уже есть новая экспертиза!');
    } else {
      this.isActiveExpertises.unshift({
        id: null,
        date: null,
        number: null,
        expertiseType: 1,
        expertiseTypeTitle: 'государственная',
        hasConclusion: false,
        hasKenml: false,
        hasPSD: false,
        hasPermission: false,
        isActive: false,
        isEdit: true,
        isIntegration: true
      });
    }
  }

  getRemovedIndex(index: number, item: IExpertiseDoc) {
    if (confirm('Вы уверены, что хотите удалить экспертизу?')) {
      if (item.id) {
        console.log('delete from server');
      } else {
        this.isActiveExpertises.splice(index, 1);
      }
    }
  }

  updateSignSample($event: boolean) {
    if ($event) {
      this.expService.getSampleSignInfo().subscribe(res => {
        this.sampleSignInfo = res;
      });
    }
  }

  getCreated($event: boolean) {
    if ($event) {
      this.expService.getExpertises(this.livingComplexID).subscribe(res => {
        this.divideExpertises(res);
      });
    }
  }

  getActiveChange(event: boolean, expertise: IExpertiseDoc) {
    expertise.isActive = event;
    this.divideExpertises(this.expertises);
  }

  trackByExpertise = (_: number, x: { id?: number; number?: any }) => x?.id ?? x?.number ?? _;


}
